import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const learningManagementRoutes = [
    {
        path: RouterPaths.WORKLOAD,
        element: importPages.Workload,
    },
    {
        path: RouterPaths.WORKLOADSETTINGS,
        element: importPages.WorkLoadSettings,
    },
    {
        path: RouterPaths.UNITEDITEM,
        element: importPages.UnitedItem,
    },
    {
        path: RouterPaths.WORKLOADITEM,
        element: importPages.WorkloadItem,
    },
    {
        path: RouterPaths.ELECTIVESUBJECTS,
        element: importPages.ElectiveSubjects,
    },
    {
        path: RouterPaths.ELECTIVEITEM,
        element: importPages.ElectiveItems,
    },
    {
        path: RouterPaths.UNITEDLESSONS,
        element: importPages.UnitedLessons,
    },
    {
        path: RouterPaths.LEARNINGPLANINFORMATION,
        element: importPages.LearningPlanOpen,
    },
    {
        path: RouterPaths.SUBJECTGROUPS,
        element: importPages.SubjectGroups,
    },
    {
        path: RouterPaths.BASELINEITEMS,
        element: importPages.BaselineItems,
    },
    {
        path: RouterPaths.LEARNINGPLANTRASH,
        element: importPages.LearningPlanRestore,
    },
    {
        path: RouterPaths.COMPETENCES,
        element: importPages.Competences,
    },
    {
        path: RouterPaths.COMPETENCESSETTINGS,
        element: importPages.CompetencesSettings,
    },
    {
        path: RouterPaths.EDUCATIONALBLOCKS,
        element: importPages.EducationalBlocks,
    },
    {
        path: RouterPaths.LEARNINGPLAN,
        element: importPages.LearningPlan,
    },

    {
        path: RouterPaths.LEARNINGPLANSETTINGS,
        element: importPages.LearningPlanSettings,
    },
    {
        path: RouterPaths.BASELINE,
        element: importPages.Baseline,
    },
    {
        path: RouterPaths.BASELINEDATA,
        element: importPages.BaselineData,
    },
    {
        path: RouterPaths.BASELINEDATASETTING,
        element: importPages.BaselineDataSetting,
    },
    {
        path: RouterPaths.ACADEMICSTRUCTURE,
        element: importPages.AcademicStructure,
    },
    {
        path: RouterPaths.ACADEMICSCHEDULING,
        element: importPages.AcademicScheduling,
    },
    {
        path: RouterPaths.ACADEMICSTRUCTURESETTINGS,
        element: importPages.AcademicStructureSettings,
    },
];
export default learningManagementRoutes
